import { render } from "./LibraryEntryTypeIcon.vue?vue&type=template&id=c2fdb344"
import script from "./LibraryEntryTypeIcon.vue?vue&type=script&lang=js"
export * from "./LibraryEntryTypeIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__